var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObstetrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.6 512.1m-448.2 0a448.2 448.2 0 1 0 896.4 0 448.2 448.2 0 1 0-896.4 0Z",
    fill: "#6665FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M424.1 335.3a90 91.7 0 1 0 180 0 90 91.7 0 1 0-180 0Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M576.2 643c-30 0-54.3-24.8-54.3-55.3 0-30.5 24.3-55.3 54.3-55.3 30 0 54.3 24.8 54.3 55.3 0.1 30.6-24.3 55.3-54.3 55.3z m70.4-153.7s-20.9-40.7-63.6-40.7H428.7s-28.1-2.8-47.2 28.7c-16.9 27.8-52.7 89.7-62.2 142.4S327.5 720.8 371 743c43.6 22.2 77.6 33.3 130.7 30.5 13.2-0.5 52.2-15.3 49.5-47.6-2.7-32.4-42.7-33.3-42.7-33.3S396 682.5 395.1 662.1c0-4.6 61.7 4.6 62.6-22.2 0.9-26.8-25.4-49.9-5.4-64.7 20-14.8 30 11.1 51.8 43.4 21.8 32.4 40.9 35.1 74.4 38.8 0 0-30 30.5-19.1 50.8 10.9 20.3 36.3 30.5 77.2 7.4 40.9-23.1 69-64.7 69-101.7 0-36.8-59-124.6-59-124.6z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObstetrics);
export default __webpack_public_path__ + "static/media/obstetrics.3d88192ea2982d64745fd7976093c1c8.svg";
export { ForwardRef as ReactComponent };